import React from "react";
import { MenuItem } from "../hooks/useHeader";
import { Link } from "gatsby";

interface Props {
  item: MenuItem;
}

export const DesktopNavItem = ({ item }: Props) => {
  return (
    <div
      style={{
        display: "flex",
        position: "relative",
      }}
    >
      <Link
        className="Header__nav_item"
        to={item.link}
        target={item.target}
        onMouseEnter={item?.handleOpenSubMenu}
      >
        {item.name}
        <div className="Header__nav_line" />
      </Link>
      {item?.openSubMenu && item?.submenuElement}
    </div>
  );
};
